/**
 * PickerRegionFilter — the create-booking picker's region control (BON-142): a
 * hierarchical tree-select rather than a chip row, because Nebari regions nest
 * (a picked parent expands to its subtree server-side) and a flat pill row does
 * not scale to the admin's full region count. Reuses the same `RegionTreeSelect`
 * the region-assignment admin UI uses.
 *
 * The REBOOK picker has no equivalent: its targets are confined to one region by
 * the server, so it renders a fixed label instead of a control.
 */
import type { RegionNode } from '../../../api/regions';
import RegionTreeSelect from '../../../shared/RegionTreeSelect';

export interface PickerRegionFilterProps {
  regions: RegionNode[];
  regionId: string | null;
  onRegionChange: (id: string | null) => void;
  /** True when the viewer may only create bookings in their own regions, so the
   *  "all regions" option is withheld — it would offer workshops whose submit
   *  could never succeed. */
  confined?: boolean;
}

export function PickerRegionFilter({
  regions,
  regionId,
  onRegionChange,
  confined = false,
}: PickerRegionFilterProps) {
  return (
    <div>
      <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-stone-400">
        Region
      </span>
      <RegionTreeSelect
        regions={regions}
        value={regionId ?? ''}
        onChange={(id) => onRegionChange(id === '' ? null : id)}
        clearLabel={confined ? undefined : 'All regions'}
        className="max-w-xs"
      />
      {confined && (
        <p className="mt-1 text-xs text-stone-500">You can book workshops in your own regions.</p>
      )}
    </div>
  );
}
